export class CurrencyHelper {
    static formatNumberToCurrency(aValue, addUnit=false){
        if (aValue !== null){
            aValue = Number(aValue).toLocaleString('en-US');
            if(addUnit)
                aValue = `$ ${aValue}`
        }

        return aValue;
    }

    // Devuelve las monedas únicas (ej: ['ARS', 'USD']) de los items seleccionados
    // en el Explorador. Si selectedItems está vacío o no se identifica moneda, devuelve [].
    // sourceType: 'BUSINESS_UNITS' o 'AD_ACCOUNTS' (constantes en nodeToGSheet.js).
    static getCurrenciesOfSelection({ selectedItems, sourceType, adAccounts = [], businessUnits = [] }) {
        if (!Array.isArray(selectedItems) || selectedItems.length === 0) return [];

        const set = new Set();

        if (sourceType === 'AD_ACCOUNTS') {
            for (const itemId of selectedItems) {
                if (typeof itemId !== 'string') continue;
                const [channel, accountIdRaw] = itemId.split('__');
                if (!channel || !accountIdRaw) continue;
                const accountId = String(accountIdRaw);
                const aa = adAccounts.find(a =>
                    a && a.channel === channel && String(a.account_id) === accountId
                );
                if (aa && aa.currency) set.add(aa.currency);
            }
        } else if (sourceType === 'BUSINESS_UNITS') {
            for (const itemId of selectedItems) {
                const bu = businessUnits.find(b => b && String(b.id) === String(itemId));
                if (bu && bu.currency) set.add(bu.currency);
            }
        }

        return Array.from(set);
    }
}
